import React, { useState } from "react";
import { NavLink } from "react-router-dom";

import ForgetPassLeft from "../assets/images/login/forgetPassword.png";
import LogoLogin from "../assets/login/logo-round.svg";
import { forgotPassword } from "../actionCreator/commonActionCreator";
import { msgEnum } from "../config";
import { useDispatch } from "react-redux";
import { isValidEmail } from "../utils";
import { useAlert } from "../context/AlertProvider";
import "../assets/css/style.css";

const ForgetPassword = () => {
  const [form, setForm] = useState({ email: "" });
  const [errorObj, setError] = useState();
  const [msg, setMsg] = useState();
  const dispatch = useDispatch();
  const { showAlert } = useAlert();

  const OnInputChange = (ele) => {
    setError();
    setMsg();
    setForm({
      ...form,
      [ele.target.name]: ele.target.value,
    });
  };

  const validateForm = async () => {
    setMsg();
    let errObj;
    let errCnt = false;
    errObj = {
      ...errObj,
      error: "",
    };
    if (!form?.email) {
      errCnt = true;
      errObj = {
        ...errObj,
        email: "Please enter email.",
      };
    } else {
      const isValid = isValidEmail(form?.email);
      if (!isValid) {
        errCnt = true;
        errObj = {
          ...errObj,
          email: "Please enter valid email.",
        };
      }
    }
    setError(errObj);
    if (!errCnt) {
      const res = await dispatch(forgotPassword(form?.email));
      if (res?.response?.status === 404) {
        showAlert("error", "No account found with this email.");
        setError({ general: "No account found with this email." });
      }
      if (res?.status === 200) {
        setMsg(msgEnum.FORGOT_PASSWORD_MSG);
        setForm({ email: "" });
      }
    }
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      validateForm();
    }
  };

  const year = new Date().getFullYear();

  return (
    <>
      <div style={{ margin: 20 }}>
        <NavLink to={"/"}>
          <img src={LogoLogin} alt="Logo" />
        </NavLink>
      </div>
      <div className="logincontainer">
        <div className="layer">
          <div className="main-agile1">
            <div className="main-agile">
              <div className="alert-close"> </div>
              <div>
                <NavLink to={"/"}>
                  <img
                    src={ForgetPassLeft}
                    alt="Go back to Home Page"
                    style={{ height: 300 }}
                  />
                </NavLink>
              </div>
              <div className="content-wthree roboto-regular">
                <h2>Welcome! User</h2>
                <h4>
                  Not yet registered? Please{" "}
                  <NavLink to={"/signup"}>Register</NavLink> now.
                </h4>
                <div className="bottom-w3l">
                  <p>Need any assistance? </p>
                  <p>
                    <strong>Call +91-9625-981200</strong>
                  </p>
                </div>
              </div>
            </div>

            <div className="w3layouts-main">
              <i className="fa fa-lock" aria-hidden="true"></i>
              <h2 className="roboto-regular mt10">Forgot Password</h2>
              <br />
              <br />
              <form>
                <div className="email">
                  {!!errorObj?.general && (
                    <p
                      style={{
                        color: "red",
                        textAlign: "center",
                        paddingBottom: "20px",
                      }}
                    >
                      {errorObj?.general}
                    </p>
                  )}

                  {!!msg && (
                    <div
                      style={{
                        paddingBottom: "20px",
                      }}
                    >
                      {msg}
                    </div>
                  )}

                  <input
                    className="roboto-regular"
                    placeholder="E Mail Address*"
                    name="email"
                    type="email"
                    value={form?.email}
                    required=""
                    onChange={OnInputChange}
                  />

                  <span className="icons i1">
                    <i className="fa fa-envelope" aria-hidden="true"></i>
                  </span>
                  <div className="error">{errorObj?.email}</div>
                </div>

                <input
                  className="roboto-regular"
                  type="button"
                  value="Submit"
                  name="submit"
                  onClick={validateForm}
                  onKeyPress={handleKeyPress}
                />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />

                <p className="roboto-regular">
                  <strong>
                    Already have an account?{" "}
                    <NavLink to={"/signin"} className="text-color-primary">
                      Login
                    </NavLink>
                  </strong>
                </p>
              </form>
            </div>

            <div className="clear"></div>
          </div>
          <div className="footer-w3l">
            <p className="agileinfo roboto-regular">
              <strong>© {year} Beyond Leadz. All rights reserved.</strong>
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgetPassword;
